import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardSettingComponent } from './dashboard-setting.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
  ],
  declarations: [DashboardSettingComponent],
  exports: [DashboardSettingComponent]
})
export class DashboardSettingModule { }
